/**
 * @module mapbs.components.reportpanel.service.realestateselection
 */

import angular from 'angular';
import olFeature from 'ol/Feature.js'; // eslint-disable-line no-unused-vars
import olFormatWFS from 'ol/format/WFS.js';
import * as olFormatFilter from 'ol/format/filter.js';

const moduleRealestateselection = angular.module('mapbsRealestateselectionModule', []);

class RealEstateSelectionService {
    /**
   * @constructor
   * @ngInject
   * @param {angular.$injector} $injector
   * @param {angular.$http} $http
   */

    constructor($injector, $http) {
    /** @type {string} */
        this.mapservurl = $injector.get('mapserverUrl');
        this.http = $http;
    }
    /**
   * @param {!import("ol/geom/Geometry.js").default} coord
   * @returns {angular.$q.Promise<Array<olFeature>>}
   */
    getFeatureByCoord(coord) {
        const featureRequest = new olFormatWFS().writeGetFeature({
            featurePrefix: 'osm',
            featureNS: 'https://map.geo.bs.ch',

            featureTypes: [
                'BS_Liegenschaften_Grundstuecke_Liegenschaftsparzelle',
                'BS_Liegenschaften_Grundstuecke_Allmendparzelle',
                'BS_Liegenschaften_Grundstuecke_Unterbaurecht',
                'BS_Liegenschaften_Grundstuecke_Baurecht',
                'BS_Liegenschaften_Grundstuecke_andereDienstbarkeit',
            ],
            filter: olFormatFilter.intersects('the_geom', coord),
        });

        const body = new XMLSerializer().serializeToString(featureRequest);
        const params = {};

        return this.http
      .post(this.mapservurl, body, {
          params,
          headers: {'Content-Type': 'text/xml; charset=UTF-8'},
      })
      .then((response) => {
          return new olFormatWFS().readFeatures(response.data);
      });
    }
}

moduleRealestateselection.service('mapbsRealEstateSelectionService', RealEstateSelectionService);

export default moduleRealestateselection;
